"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusColor = exports.statusTranslation = exports.VALIDATION_STATUSES = void 0;
exports.VALIDATION_STATUSES = {
    TO_REVIEW: 'toReview',
    REVIEWED: 'reviewed',
    VALIDATED: 'validated',
};
exports.statusTranslation = {
    toReview: 'À relire',
    reviewed: 'Relue',
    validated: 'Validée',
};
exports.statusColor = {
    toReview: 'warning', // refers to theme
    reviewed: 'info',
    validated: 'success',
};
//# sourceMappingURL=analysis.js.map